module.exports = __webpack_public_path__ + "static/media/feature-communications.ab1e3c81.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/login/marketing/feature-communications.svg
// module id = 13908
// module chunks = 0